import { FC } from "react"
import { UnitCard } from "./unit-card"
import { Card, CardContent } from "../ui/card"
import { PlusIcon } from "lucide-react"
import { Unit, Bin } from "../../lib/types"

type UnitCardListProps = {
  units: Unit[]
  bins: Bin[]
  onEditUnit: (unitId: string) => void
  onAddUnit: () => void
}

export const UnitCardList: FC<UnitCardListProps> = ({
  units,
  bins,
  onEditUnit,
  onAddUnit
}) => {
  const getBinCount = (unitId: string) => {
    return bins.filter(bin => bin.unit === unitId).length
  }

  return (
    <>
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {units.map((unit) => (
            <UnitCard
              key={unit.id}
              name={unit.name}
              abbreviation={unit.abbreviation}
              binCount={getBinCount(unit.id)}
              onClick={() => onEditUnit(unit.id)}
            />
          ))}

          {/* Add Unit Card */}
          <Card
            onClick={onAddUnit}
            className="cursor-pointer border-2 border-dashed border-neutral300 dark:border-neutral600 hover:border-sumoPrimary dark:hover:border-sumoPrimary hover:bg-sumoPrimary/5 dark:hover:bg-sumoPrimary/10 transition-all duration-200 dark:bg-neutral800/50"
          >
            <CardContent className="pt-6">
              <div className="flex flex-col items-center justify-center gap-3 py-8">
                <div className="w-12 h-12 rounded-full bg-neutral100 dark:bg-neutral700 flex items-center justify-center">
                  <PlusIcon className="text-neutral500 dark:text-neutral400" width={24} height={24} />
                </div>
                <div className="text-center">
                  <p className="font-semibold text-neutral700 dark:text-neutral300">Add Storage Unit</p>
                  <p className="text-xs text-neutral500 dark:text-neutral400 mt-1">Create a new unit</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {units.length === 0 && (
          <p className="text-sm text-neutral500 dark:text-neutral400 italic">
            No storage units yet. Click "Add Storage Unit" to create your first one.
          </p>
        )}
      </div>
    </>
  )
}
